// extracted by mini-css-extract-plugin
export default {"footer":"_3pw9R0NV"};